// @ts-strict-ignore FIXME: type all methods
import Analytics from 'APP/Services/Analytics'
import { setDdUser } from 'APP/Lib/Datadog'

const selectProfile = (action, state) => (action && action.profile) || state?.patient?.profile || {}

const selectDeeplinkUserId = (action, state) => {
  const isDeferredDeeplink =
    ['SET_DEFERRED_DEEPLINK', 'REJECT_DEFERRED_DEEPLINK'].indexOf(action.type) > -1
  if (isDeferredDeeplink) {
    return (action.props || (state.deeplink || {}).props || {}).user_id
  }
}

const selectUserId = (action, state) => {
  const profile = selectProfile(action, state)
  const deeplinkUserId = selectDeeplinkUserId(action, state)
  return String((profile && profile.id) || deeplinkUserId) || null
}

export default (store) => (next) => (action) => {
  if (!action.type) return next(action)

  const state = store.getState()

  const userId = selectUserId(action, state)

  if (userId) {
    setDdUser({ id: userId })
  }
  /**
   * TEMPORARY FIX - Race Condition Workaround
   * @see https://dialoguemd.atlassian.net/browse/DIA-85713
   *
   * Analytics.identify() is called here before Analytics may be initialized,
   * causing a race condition. The current fix adds guard checks in Analytics
   * that silently return early if not initialized.
   *
   * This approach has issues:
   * - Silent data loss: Early analytics events are dropped
   * - Difficult to debug: No visibility when events are lost
   * - Not future-proof: Requires guard checks on all Analytics methods
   *
   * Proper solution: Ensure Analytics is initialized before Redux store creation,
   * or implement a command queue to buffer events until initialization completes.
   */
  if (userId && userId !== undefined) {
    Analytics.identify(userId)
  } else if (action.type === 'LOGOUT') {
    Analytics.clearIdentify()
  }

  return next(action)
}
